import { render, staticRenderFns } from "./PatientMemoDialog.vue?vue&type=template&id=5105584c&"
import script from "./PatientMemoDialog.vue?vue&type=script&lang=ts&"
export * from "./PatientMemoDialog.vue?vue&type=script&lang=ts&"
import style0 from "./PatientMemoDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VSpacer})
